/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_SyncInputs */



/**
* | output |
* | --- |
* | "Plan updated from the payment processor" |
*
* @param {Activity_Billing_SyncInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_sync = /** @type {((inputs?: Activity_Billing_SyncInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_SyncInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тариф обновлён по данным платёжной системы")
	return /** @type {LocalizedString} */ ("Plan updated from the payment processor")
});